// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"H4-z","displaySixCardTiles":"I4-z"};